import { useCallback, useState } from 'react';

const STORAGE_KEY = 'partsWidget.admin.drawerExpanded';

function readInitial(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'true') return true;
    if (stored === 'false') return false;
  } catch {
    // ignore
  }

  return true;
}

function persist(value: boolean) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
  } catch {
    // ignore
  }
}

export function useAdminPreferences() {
  const [drawerExpanded, setDrawerExpanded] = useState<boolean>(() => readInitial());

  const setExpanded = useCallback((value: boolean) => {
    setDrawerExpanded(value);
    persist(value);
  }, []);

  const toggleExpanded = useCallback(() => {
    setExpanded(!drawerExpanded);
  }, [drawerExpanded, setExpanded]);

  return {
    drawerExpanded,
    setDrawerExpanded: setExpanded,
    toggleDrawerExpanded: toggleExpanded,
  };
}
